import React from "react"
import Icon from "components/elements/Icon"

const MergeFieldInsertIcon = () => (
  <Icon icon="plus" size={3} color="white" />
)

export default MergeFieldInsertIcon
